/* ==========================================================================
   Product page gallery
   Adds previous / next arrows, an "n / total" counter, swipe on touch
   screens and a soft fade between images. Image switching itself stays
   with theme.js: every control here simply clicks the matching thumbnail,
   so there is one source of truth for which image is showing.
   ========================================================================== */
(function () {
  'use strict';

  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  function init() {
    var main = document.getElementById('galleryMain');
    var frame = main && main.closest('.gallery-main');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb-btn'));
    if (!frame || thumbs.length < 2 || frame.dataset.galleryReady) return;
    frame.dataset.galleryReady = '1';

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function makeButton(cls, label, icon) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery-nav ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = icon;
      frame.appendChild(b);
      return b;
    }
    var prev = makeButton('gallery-nav--prev', 'Previous image', ICON_PREV);
    var next = makeButton('gallery-nav--next', 'Next image', ICON_NEXT);

    var count = document.createElement('span');
    count.className = 'gallery-count';
    count.setAttribute('aria-live', 'polite');
    frame.appendChild(count);

    function updateCount() { count.textContent = (current() + 1) + ' / ' + thumbs.length; }

    function go(step) {
      var i = (current() + step + thumbs.length) % thumbs.length;
      thumbs[i].click();
      // keep the active thumbnail visible in the scrolling strip on phones
      var strip = thumbs[i].closest('.thumb-list');
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: thumbs[i].parentElement.offsetLeft - strip.offsetLeft, behavior: 'smooth' });
      }
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    // Fade: hide while the next image loads, show once it has.
    // Capture phase, so this runs before theme.js changes the src.
    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        if (main.getAttribute('src') !== button.dataset.full) frame.classList.add('is-swapping');
        setTimeout(updateCount, 0);
      }, true);
    });
    main.addEventListener('load', function () { frame.classList.remove('is-swapping'); });
    main.addEventListener('error', function () { frame.classList.remove('is-swapping'); });

    // Swipe left / right on touch screens.
    var startX = null, startY = null;
    frame.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });

    // Warm the cache so switching images feels instant.
    window.addEventListener('load', function () {
      thumbs.forEach(function (b) { var img = new Image(); img.src = b.dataset.full; });
    });

    updateCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
